import { catchError, map } from 'rxjs/operators';
import { of, Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';
import { ProjectAPIService } from '@modules/projects/shared/services/project-api.service';
import { ProjectStoreService } from '@modules/projects/shared/services/project-store.service';
import { Project } from '@modules/projects/shared/models/project.model';

@Injectable({ providedIn: 'root' })
export class ProjectCreateGuard  {
  constructor(
    private projectAPI: ProjectAPIService,
    private projectStore: ProjectStoreService
  ) {}

  canActivate(route: ActivatedRouteSnapshot) {
    const projectDraft = this.handleRequest(this.projectAPI.findProjectByID(route.params.projectid));
    return projectDraft.pipe(
      map((project: Project | null) => {
        if (!project?.id) {
          this.projectStore.project.set(null);
          this.projectStore.projectCtrl.setProject(null);
          this.projectStore.setDefault();
          return false;
        }

        this.projectStore.project.set(project);
        this.projectStore.projectCtrl.setProject(project);
        this.projectStore.setDefault();
        this.projectStore.setInitialFormValues();
        return true;
      })
    );
  }

  handleRequest(observable: Observable<any>): Observable<any> {
    return observable.pipe(
      catchError((err) => {
        return of(null);
      })
    );
  }
}
